import React, { useState } from 'react';
import { shuffle, cleanTheScript } from '../../../helpers';

import styles from './QuizQuestion.module.css';

const QuizQuestion = props => {
	const block = props.block;
	const script = cleanTheScript(block.script);
	const question = cleanTheScript(block.question);
	const [originalOptions] = useState({ options: [...block.options] });
	const [shuffledOptions] = useState({ options: [...shuffle(block.options)] });
	const [selectedAnswer, setSelectedAnswer] = useState(null);
	const [showAnswer, setShowAnswer] = useState(false);
	const [isAnswerCorrect, setAnswerIsCorrect] = useState(false);
	const [isAnswerWrong, setAnswerIsWrong] = useState(false);
	const [proceedToNext, setProceedToNext] = useState(false);
	const [closeQuiz, setCloseQuiz] = useState(false);

	const showCorrectAnswer = () => {
		setShowAnswer(true);
		if (props.quizMode && !props.finalQuestion) setProceedToNext(true)
		else setCloseQuiz(true)

		if (selectedAnswer === originalOptions.options[0]) {
			setAnswerIsCorrect(true);
			if (!props.quizMode) {
				props.blockAnswered('correct')
			} else props.correctAnswer();
		} else {
			setAnswerIsWrong(true);
			if (!props.quizMode) props.blockAnswered('wrong')
		}
	}

	const selectAnswer = option => {
		setSelectedAnswer(option);
		// console.log('CORRECT ANSWER:', originalOptions.options[0])
	}

	const buttonClicksHandler = event => {
		event.stopPropagation();
		if (!props.quizMode) {
			closeQuiz ? props.closeQuiz() : showCorrectAnswer();
		} else {
			if (proceedToNext) props.doneWithThisQuestion();
			else closeQuiz ? (props.finalQuestion ? props.doneWithThisQuestion() : props.closeQuiz()) : showCorrectAnswer();
		}
	}

	const optionBullets = ['A', 'B', 'C', 'D'];
	const longOptions = shuffledOptions.options.filter(option => option.length > 145).length > 0;  // if either one of the options has long text, we add some styling to all options for a consistent look
	const options = shuffledOptions.options.map((option, index) => {
		let answerMark = null;
		const answerMarkStyle = { left: longOptions ? '-36px' : '-27px' };
		const showCorrectOption = showAnswer && originalOptions.options[0] === option;
		const wrongAnswerSelected = selectedAnswer === option && isAnswerWrong;
		const correctAnswerSelected = selectedAnswer === option && isAnswerCorrect;
		const optionStyleCondition = selectedAnswer === option || showCorrectOption;
		let optionStyle = {};
		if (closeQuiz || proceedToNext) {
			if (optionStyleCondition) optionStyle = { backgroundColor: '#fff', color: '#000', pointerEvents: 'none' }
			else optionStyle = { backgroundColor: props.optionsColor, pointerEvents: 'none' }
		} else optionStyle = optionStyleCondition ? { backgroundColor: '#fff', color: '#000' } : {backgroundColor: props.optionsColor}

		if (!props.showScript) optionStyle = { ...optionStyle, margin: '20px 0', minHeight: '80px' }
		else optionStyle = { ...optionStyle, margin: '10px 0', minHeight: '60px' }

		if (props.quizMode && optionStyle["backgroundColor"] !== "#fff") optionStyle["backgroundColor"] = props.optionsColor;

		if (wrongAnswerSelected) {
			answerMark = (
				<span className={styles.AnswerMarkContainer} style={answerMarkStyle}>
					<i className={`fa fa-remove ${styles.WrongAnswerMark}`} />
				</span>
			)
		}

		if (correctAnswerSelected || showCorrectOption) {
			answerMark = (
				<span className={styles.AnswerMarkContainer} style={answerMarkStyle}>
					<i className={`fa fa-check fa-fw ${styles.CorrectAnswerMark}`} />
				</span>
			)
		}

		if (longOptions) optionStyle = { ...optionStyle, padding: '0 10px', lineHeight: '18px' }

		return (
			<p onClick={() => selectAnswer(option)} className={styles.Option} style={optionStyle} key={index} >
				{answerMark}
				<span className={styles.optionBullet}> {optionBullets[index]}</span>
				{option.trim()}
			</p>
		)
	});

	const buttonStyle = {
		pointerEvents: selectedAnswer === null ? 'none' : 'auto',
		opacity: selectedAnswer === null ? '.25' : '1'
	};

	const buttonText = (
		proceedToNext ? 'Proceed'
		: closeQuiz ? 'Close'
		: 'Check Answer'
	);

	const answerStateInHeading = (
		props.quizMode ? (isAnswerCorrect ? 'CORRECT! ' : isAnswerWrong ? 'WRONG! ' : null) : null
	);

	let mainScript = null;
	let questionContainer = [
		<h4 key='h4' className={styles.Question} style={{ padding: !props.showScript ? '20px 0 10px' : '5px 0' }}>
			{answerStateInHeading}{question}
		</h4>,
		<div key='whatever' className={styles.OptionsContainer}>
			{options}
		</div>
	];

	if (props.showScript) {
		mainScript = (
			<div className={styles.ScriptContainer}>
				<p className={styles.Script}>{script}</p>
			</div>
		);

		questionContainer = (
			<div className={styles.QuestionContainer}>
				<h4 className={styles.Question}>
					{answerStateInHeading}{question}
				</h4>
				<div className={styles.OptionsContainer}>
					{options}
				</div>
			</div>
		);
	}

	return (
		<div className={styles.QuizContainer}>
			{mainScript}
			{questionContainer}
			<div className={styles.MainButtonContainer} style={buttonStyle}>
				<div className={styles.MainButton} onClick={event => buttonClicksHandler(event)} >
					<span className={styles.IconContainer}>
						<i className={closeQuiz ? styles.CloseQuizIcon + " fa fa-remove" : styles.NextStepIcon + " fa fa-arrow-right fa-fw"} />
					</span>
					<span>{buttonText}</span>
				</div>
			</div>
		</div>
	);
};

export default QuizQuestion;